'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const industries = [
	{
		title: 'Промышленность',
		description: 'Разрабатываем ERP и MES-системы, внедряем инструменты для мониторинга оборудования и контроля качества. Создаём решения для автоматизации склада и внутренней логистики, которые снижают издержки и простои.',
		icon: '/services/factory.svg'
	},
	{
		title: 'Ритейл',
		description: 'Создаём решения для торговли: интернет-магазины, B2B-порталы и мобильные приложения. Бесшовно интегрируем онлайн-продажи с 1С, CRM и складскими системами, программы лояльности и инструменты персонализации.',
		icon: '/services/shopping_cart.svg'
	},
	{
		title: 'Строительство',
		description: 'Разрабатываем цифровые сервисы для застройщиков и поставщиков. Создаём B2B-маркетплейсы материалов, тендерные площадки и системы управления проектами. Оптимизируем процессы закупок и логистику поставок.',
		icon: '/services/handyman.svg'
	},
	{
		title: 'Финансы',
		description: 'Разрабатываем финансовые продукты любой сложности: от платёжных шлюзов и систем ДБО до сервисов автоматизации казначейства. Внедряем мультибанкинг, настраиваем интеграции с банками и обеспечиваем безопасность транзакций по стандартам PCI DSS.',
		icon: '/services/account_balance_wallet.svg'
	},
	{
		title: 'Общепит',
		description: 'Разрабатываем ПО для управления производственными линиями и складского учёта сырья. Внедряем системы контроля качества, которые помогают наращивать объёмы выпуска и снижать потери. Автоматизируем рабочие процессы предприятий.',
		icon: '/services/restaurant.svg'
	},
	{
		title: 'Юридические услуги',
		description: 'Автоматизируем работу юридических компаний и департаментов. Создаём защищённые клиентские порталы, системы ЭДО и внутренние базы знаний. Гарантируем полную конфиденциальность и безопасность чувствительных данных',
		icon: '/services/gavel.svg'
	}
]

const Industries: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Направления
					</Typography>
					<Typography variant='h2' className={styles.title}>
						Отрасли, в которых мы работаем
					</Typography>
				</div>
			</AnimatedSection>

			<AnimatedSection animation="slideUp">
			<div className={styles.grid}>
				{industries.map((industry, idx) => (
					<div key={idx} className={styles.card}>
						<div className={styles.iconContainer}>
							<img src={industry.icon} alt={industry.title} className={styles.icon} />
						</div>
						<Typography variant='h4' className={styles.cardTitle}>
							{industry.title}
						</Typography>
						<Typography variant='p1' color='description' className={styles.cardDescription}>
							{industry.description}
						</Typography>
					</div>
				))}
			</div>
			</AnimatedSection>
		</section>
	)
}

Industries.displayName = 'Industries'

export default Industries

